module.exports = __webpack_public_path__ + "static/media/star.254b4da1.svg";